module.exports = __webpack_public_path__ + "static/media/cc-waiting-english.b7d29b6e.vtt";